import Dot from './Dot';

export default Dot;
export * from './Dot';
